import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import {ConfService} from '../../conf.service';
import {DialogData} from '../admin-consumers/create-consumer-dialog/create-consumer-dialog.component';

@Component({
  selector: 'app-view-exclusions-dialog',
  templateUrl: './view-exclusions-dialog.component.html',
  styleUrls: ['./view-exclusions-dialog.component.scss']
})
export class ViewExclusionsDialogComponent implements OnInit {

  constructor(
      public dialogRef: MatDialogRef<ViewExclusionsDialogComponent>,
      public dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
  }

}
